<template>
  <mt-tabbar v-model="message" fixed>
    <mt-tab-item id="home">
      <img slot="icon" src="../assets/home.png">
      主页
    </mt-tab-item>
    <mt-tab-item id="my">
      <img slot="icon" src="../assets/my.png">
      我的
    </mt-tab-item>
  </mt-tabbar>
</template>

<script>
export default {
  data() {
    return {
      //选中的tabbar值message为外面页面传入的值selected
      message: this.selected,
    }
  },
  props: {
    selected: String,
  },
  watch: {
    message: function (val, oldVal) {
      // 这里就可以通过 val 的值变更来确定去向
      switch (val) {
        case 'home':
          this.$router.push('/');
          break;
        case 'my':
          this.$router.push('/exit');
          break;
      }
    }
  },
}
</script>

<style>
.mint-tabbar {
  background-color: #fff !important;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05) !important;
  height: 60px !important;
  border-top: 1px solid #f1f3f5 !important;
  background-image: none !important;
}

.mint-tabbar > .mint-tab-item {
  color: #adb5bd !important;
  padding: 8px 0 !important;
}

.mint-tabbar > .mint-tab-item.is-selected {
  color: #106EBE !important;
  background-color: transparent !important;
}

.mint-tabbar > .mint-tab-item .mint-tab-item-icon {
  width: 24px !important;
  height: 24px !important;
  margin-bottom: 4px !important;
}

.mint-tabbar > .mint-tab-item .mint-tab-item-label {
  font-size: 12px !important;
  font-weight: 600 !important;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f6f8fa;
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar.vue